export const MenuItems = [
  {
    title: 'Item 1',
    path: '/learn',
    cName: 'drop-d-link'
  },
  {
    title: 'Item 2',
    path: '/learn',
    cName: 'drop-d-link'
  },
  {
    title: 'Item 3',
    path: '/learn',
    cName: 'drop-d-link'
  }
];

// Porium, gitcoin quests, hackathon